import React from 'react';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';

import styles from './styles.module.less';
import { useReturnNavigation } from '../../../../../orders/order-details/hooks/use-return-navigation';
import Global from '../../../../../store/global-selectors';

export const ReturnsRequestNumberColumn = ({ id = '', returnNumber = '', salesOrderId = '' }) => {
  const salesOrder = useSelector((state) => {
    if (!salesOrderId) {
      return null;
    }
    return Global.selectEntitiesSalesOrderById(state, { salesOrderId });
  });
  const { navigateToReturn } = useReturnNavigation();
  const storeSupportsEnhancedReturns = true;
  const onClick = () => navigateToReturn(salesOrderId, id, storeSupportsEnhancedReturns);

  return (
    <div className={styles['request-number']}>
      {salesOrder ? (
        <Button onClick={onClick} theme='link'>
          {returnNumber}
        </Button>
      ) : null}
      {!salesOrder && <>{returnNumber}</>}
    </div>
  );
};
